import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@techsofit/app-kit';
import { ConfirmProvider } from '@techsofit/ui';
import { router } from './router';
import { captureRef } from './lib/attribution';
import './index.css';

// Stash any ?ref= attribution tag for the session before the app renders.
captureRef();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider allowedRoles={['GYM_OWNER', 'GYM_STAFF']}>
      <ConfirmProvider>
        <RouterProvider router={router} />
      </ConfirmProvider>
    </AuthProvider>
  </StrictMode>,
);
